import { Home } from '@systemeio/digital-store-shared'
import AddItemModal from 'modules/stores/store/components/add-item-modal'
import ProfileContent from 'modules/stores/store/content/profile/profile-content'
import { useStorePreviewContext } from 'modules/stores/store/context/store-preview-context'
import { useStore } from 'modules/stores/store/hooks/use-store'
import { useStoreItemActions } from 'modules/stores/store/hooks/use-store-item-actions'
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query'
import { getItemContentByType } from 'modules/stores/store/utils/get-item-content-by-type'
import { StoreInterface } from 'modules/stores/types/stores-interface'
import React, { FC, Fragment, useEffect } from 'react'
import Sortable from 'shared/components/sortable'
import { reorderData } from 'shared/components/table/sortable-table/reorder-data'
import AddHeader from '../content/header/add-header'

interface ContentProps {
  storeView: StoreInterface
}

const StoreContent: FC<ContentProps> = ({ storeView }) => {
  const { setPreview, setSingleItemMode } = useStorePreviewContext()

  useEffect(() => {
    setPreview([
      <Home
        key={storeView.id}
        profile={storeView.profile}
        socialLinks={storeView.socialLinks}
        items={storeView.items.filter(el => !el.draft)}
        displayAffiliateLink={false}
      />,
    ])
    setSingleItemMode(false)
  }, [setPreview, setSingleItemMode, storeView])

  const { storeId } = useStoreQuery()
  const { mutate } = useStore(storeId)

  const { reorderItem } = useStoreItemActions()

  const onMoveItem = async (activeId: number, activeIndex: number, overIndex: number) => {
    await mutate(
      async data => {
        await reorderItem(activeId, overIndex + 1)
        return reorderData({ data, activeIndex, overIndex, sortableKey: 'items' })
      },
      {
        optimisticData: data => reorderData({ data, activeIndex, overIndex, sortableKey: 'items' }),
        rollbackOnError: true,
        revalidate: false,
      },
    )
  }

  return (
    <div className={'flex flex-col gap-5'}>
      <ProfileContent profile={storeView.profile} socialMedia={storeView.socialLinks} />
      <Sortable
        draggable={getItemContentByType}
        items={storeView.items.map(item => ({ ...item, id: item.itemId }))}
        onMove={onMoveItem}
      >
        {storeView.items.map(item => (
          <Fragment key={item.itemId}>{getItemContentByType(item)}</Fragment>
        ))}
      </Sortable>
      <div className="flex flex-row justify-center gap-4 max-sm:flex-col-reverse max-sm:gap-2">
        <AddItemModal />
        <AddHeader />
      </div>
    </div>
  )
}

export default StoreContent
